import { observer } from 'mobx-react-lite'
import React from 'react'
// evertel
import { Icon, FloatingMenu, MenuItem, MenuHeader, useUI } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { UserSettingsController } from '@evertel/blue-user'
import { SessionService } from '@evertel/session/SessionService'
import { PushService } from '@evertel/push'
import { isEdgeBrowser } from '@evertel/web/utils'

type HeaderNotificationsDropdownProps = React.ButtonHTMLAttributes<HTMLButtonElement>

const HeaderNotificationsDropdown: React.FC<HeaderNotificationsDropdownProps> = observer(({
    className,
    ...otherProps
}) => {

    const { showAlertBar } = useUI()
    const sessionService = useService(SessionService, [])
    const userSettingsController = useService(UserSettingsController, [])
    const pushService = useService(PushService, [])

    const notificationsEnabled = pushService?.notificationPermission === 'granted' && userSettingsController?.notificationsEnabled

    const onToggle = async () => {
        const permission = await pushService.getCurrentNotificationPermission()

        if (permission === 'granted') {
            userSettingsController.toggleAllNotifications()
        } else if (permission === 'default') {
            await pushService.promptForNotificationPermission()

            if (isEdgeBrowser(window.navigator.userAgent)) {
                showAlertBar({ type: pushService.notificationPermission, isOpen: true })
            }
        } else {
            showAlertBar({ type: 'denied', isOpen: true })
        }
    }

    return (
        <FloatingMenu
            id="header-dropdown-notification-settings"
            label="Notification Settings"
            title="Notification Settings"
            aria-label={`Notification Settings: notifications are ${notificationsEnabled?'enabled':'disabled'}`}
            renderLabel={() => (
                <Icon
                    name={notificationsEnabled ? 'bell' : 'bell-slash'}
                    size={16}
                    className={`d-block ${notificationsEnabled ? 'text-success' : 'text-danger'}`}
                    style={{ width: 20, textAlign: 'center' }}
                />
            )}
            className={className}
            {...otherProps}
        >
            <MenuHeader label="Notifications" />
            <MenuItem
                label={notificationsEnabled ? 'Mute All Notifications' : 'Enable Notifications'}
                icon={{
                    name: notificationsEnabled ? 'bell-slash' : 'bell'
                }}
                onClick={() => onToggle()}
            />
        </FloatingMenu>
    )
})

export { HeaderNotificationsDropdown }
